
import { post, get, put, del, token, DEV_TOKEN } from './api.js';
import { groupBy, mapBy } from "./utils.js";

export async function load(id) {

    return get(`teams/?id=${id}`, token || DEV_TOKEN)
        .then(r => r.data)
        .catch(e => {
            return [];
        });
}

/**
 * Create Team.
 */
export function create(id, name) {
    return post('teams/',
        {
            id: id,
            name: name
        }, token || DEV_TOKEN);
}

/*
* Update Team
*/
export function update(id, team_id, name) {
    return put('teams/',
        {
            id: id,
            team_id: team_id,
            name: name
        }, token || DEV_TOKEN);
}

/**
 * Delete Team
 */
export function deleteTeam(id, team_id) {
    return del('teams/',
        {
            id: id,
            team_id: team_id
        }, token || DEV_TOKEN);
}

